// The Supabase SDK (~170 kB minified) is only needed once auth state is read, never for the
// first paint. Modules in the initial bundle (AuthProvider, api.js) load it through this
// dynamic import so it ships as its own chunk instead of inside index.js. Lazy route chunks may
// still import { supabase } from "./supabase.js" directly; they share the same chunk.
let pending;

export function loadSupabase() {
  pending ||= import("./supabase.js").then(
    (m) => m.supabase,
    (error) => {
      pending = undefined; // a failed chunk load may succeed on the next call
      throw error;
    },
  );
  return pending;
}
